import { CredentialVerificationLevel } from '@accredible-frontend-v2/models';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'rp-credential-verification-level',
  standalone: true,
  imports: [TranslocoDirective, MatTooltipModule, NgOptimizedImage],
  templateUrl: './credential-verification-level.component.html',
  styleUrl: './credential-verification-level.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CredentialVerificationLevelComponent {
  verificationLevel = input.required<CredentialVerificationLevel>();

  level = computed(() => this.verificationLevel() || 'unverified');
}
